"use client"

import HeaderList from "@/components/header/header-list"
import type { SiteId } from "@/sites/config"
import { HeaderMenuData, HeaderSocialLinks } from "@/types/types"

type TamdaMediaHeaderViewClientProps = {
  locale: string
  siteId: SiteId
  menuData: HeaderMenuData | null
  socialLinks?: HeaderSocialLinks
}

export function TamdaMediaHeaderViewClient({ locale, menuData, socialLinks }: TamdaMediaHeaderViewClientProps) {
  return (
    <HeaderList
      menuData={menuData}
      locale={locale}
      shouldBeTransparent={false}
      isScrolled={false}
      onSearchClick={() => {}}
      socialLinks={socialLinks}
    />
  )
}
